import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { TextField } from '@material-ui/core';
import { formErrorMessages } from '../../../../../constants/form-error-messages';
import { NationalAccountContext } from '../../../../../contexts';
import { ReturnError, ShowSpinner, ModalButtonGroup } from '../commons';
import { reloadPage } from '../../../../../utils/general';
import {
  modalBlurbs,
  nationalAccountRegex,
  shared,
} from '../../../../../constants/NationalAccount';

export const EINInputModal = (): JSX.Element => {
  const {
    validResponseState,
    setValidResponseState,
    setShowModal,
    setIsLoading,
    setErrorState,
    errorState,
    isLoading,
    enrollAgreementCode,
  } = useContext<any>(NationalAccountContext);
  const [einCodeUserInput, seteinCodeUserInput] = useState<any>('');
  const [einNotFoundError, setEinNotFoundError] = useState<any>(false);
  const [isValidInput, setIsValidInput] = useState<any>(false);
  const { register, handleSubmit, setValue } = useForm({
    mode: 'onSubmit',
  });

  const handleEnrollSubmit = async () => {
    setIsLoading(true);
    const alteredEINInput = einCodeUserInput.replace('-', '');
    const response = await enrollAgreementCode(
      true,
      validResponseState && validResponseState.agreementCodeEntered,
      alteredEINInput,
    );

    setIsLoading(false);
    if (response && !response.hasError) {
      setEinNotFoundError(false);
      setErrorState(false);
      setShowModal(false);
      if (validResponseState.requiredEINState) {
        sessionStorage.removeItem('isEnrolledInPerksProgram');
      }
      reloadPage();
    } else {
      setEinNotFoundError(true);
      setErrorState(true);
    }
  };
  const validateEINString = (input: string) => {
    const isInvalidCode =
      !input ||
      input.length === 0 ||
      !input.match(nationalAccountRegex.einRegex);
    setIsValidInput(!isInvalidCode);
  };

  const onBlurEINInput = ({
    currentTarget,
  }: {
    currentTarget: EventTarget | null;
  }) => {
    const { value } = currentTarget as HTMLInputElement;
    validateEINString(value);
  };

  const onChangeEINInput = ({
    currentTarget,
  }: {
    currentTarget: EventTarget | null;
  }) => {
    const { value } = currentTarget as HTMLInputElement;
    seteinCodeUserInput(value);
    validateEINString(value);
    setErrorState(false);
    setValue('einCodeInput', value);
  };

  const handleEnrollButton = () => {
    if (validResponseState.requiredEINState) {
      return einCodeUserInput && !errorState;
    }
    return isValidInput;
  };

  const cancelAgreement = () => {
    setErrorState(false);
    setShowModal(false);
    setValidResponseState((prevState: any) => {
      return { ...prevState, enrollState: true };
    });
  };

  return (
    <div
      data-testid="EINInputModal"
      className="sui-flex sui-flex-col sui-justify-center sui-align-start sui-font-regular sui-text-1xl"
    >
      <form onSubmit={handleSubmit(handleEnrollSubmit)}>
        <div className="sui-flex sui-flex-col sui-justify-between sui-pb-5">
          {modalBlurbs.governmentBlurbs.einDesc}
        </div>
        {isLoading && <ShowSpinner />}
        <div>
          <InputMask
            mask="99-9999999"
            value={einCodeUserInput}
            disabled={false}
            maskChar=" "
            onChange={onChangeEINInput}
            onBlur={onBlurEINInput}
          >
            {() => (
              <TextField
                fullWidth
                label={modalBlurbs.governmentBlurbs.einInputLabel}
                id="einCodeInput"
                placeholder="Enter your 9 digit number"
                error={
                  einNotFoundError && !!formErrorMessages.einInvalid.message
                }
                helperText={formErrorMessages.einInvalid.message}
                inputProps={{
                  ...register('einCodeInput', {
                    minLength: 0,
                    pattern: nationalAccountRegex.einRegex,
                  }),
                }}
              />
            )}
          </InputMask>
        </div>
        <div className="sui-flex sui-flex-row sui-justify-between sui-align-start sui-text-base sui-pb-3">
          <p>
            <b>{modalBlurbs.governmentBlurbs.note} </b>{' '}
            {modalBlurbs.governmentBlurbs.content}
          </p>
        </div>
        <div>{errorState && <ReturnError />}</div>
        <ModalButtonGroup
          disabled={!handleEnrollButton()}
          confirmBlurb={modalBlurbs.confirm.buttons.continue}
          handleClose={cancelAgreement}
          cancelBlurb={shared.cancel}
        />
      </form>
    </div>
  );
};
